<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      tableData: [],
      title: "校内順位管理",
      items: [
        {
          text: "Game",
          href: "/",
        },
        {
          text: "校内順位管理",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      search_school_code: "",
      search_sex: "", // 性別検索用
      school_code: "",
      rank: null,
      player_id: null,
      selectedPlayer: "",
      playerSearchText: "",
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: [
        "school_code",
        "school_name",
        "rank",
        "player_name",
        "player_sex",
        "player_school_year",
      ],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: false,
          tdClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: false,
          tdClass: "minWidth200",
        },
        {
          key: "rank",
          label: "校内順位",
          sortable: false,
          tdClass: "minWidth100",
        },
        {
          key: "player_name",
          label: "選手名",
          sortable: false,
          tdClass: "minWidth200",
        },
        {
          key: "player_sex",
          label: "性別",
          sortable: false,
          tdClass: "minWidth100",
        },
        {
          key: "player_school_year",
          label: "学年",
          sortable: false,
          tdClass: "minWidth100",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      schoolList: [],
    };
  },
  mounted() {
    let roles = this.$store.getters.roles;
    if (roles == "admin") {
      this.getUser("admin");
    } else if (roles == "user") {
      this.getUser("user");
      this.search_school_code = this.$store.getters.schoolCode;
    } else {
      window.location.href = "/";
      return;
    }
    this.searchItems();
  },
  computed: {
    rows() {
      return this.filterItems.length;
    },
    filteredPlayers() {
      if (!this.school_code) {
        // 学校コードが未入力の場合、すべてのプレイヤーを返す
        return this.players;
      }
      // 学校コードで絞り込む
      return this.players.filter(player => player.school_code === this.school_code);
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/ranks", {
          params: {
            school_code: this.search_school_code,
            sex: this.search_sex,
          }
        })
        .then((response) => {
          this.loading = false;
          // Playerテーブルのデータをそのまま使う
          const players = response.data.players ?? [];
          const schools = response.data.schools ?? [];
          this.tableData = players.map((item) => ({
            ...item,
          }));
          this.filterItems = this.tableData;
          this.selectAll = false;
          // 先頭に空欄を追加
          this.schoolList = [
            { value: "", text: "" },
            ...schools.map(s => ({
              value: s.school_code,
              text: s.school_code + " : " + s.school_name,
            }))
          ];
          // Playerデータを設定
          this.players = [
            { value: "", text: "" },
            ...players.map((player) => ({
              value: player.id,
              text: `${player.player_name} (学年：${player.player_school_year ?? ""}, 性別：${player.player_sex === 1 ? "男子" : player.player_sex === 2 ? "女子" : ""})`,
              school_code: player.school_code,
              sex: player.player_sex,
            })),
          ];
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/ranks/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onPlayerInput(val) {
      this.playerSearchText = val;
    },
    onPlayerSelect(option) {
      this.player_id = option.value;
    },
    // 追加
    add() {
      this.mode = "add";
      this.id = "new";
      this.school_code = this.search_school_code;
      this.rank = null;
      this.player_id = null;
      this.selectedPlayer = "";

      if (this.tableData.length > 0) {
        const maxRank = Math.max(...this.tableData.map(item => Number(item.rank) || 0));
        this.rank = maxRank + 1;
      } else {
        this.rank = 1;
      }
    },
    // 編集
    edit(item) {
      this.mode = "edit";
      this.id = item.id;
      this.school_code = item.school_code;
      this.rank = item.rank;
      this.player_id = item.id; // ←ここ
      this.selectedPlayer = this.players.find(player => player.value === item.id) || "";
    },
    // 確定
    submit() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("school_code", this.school_code);
      formData.append("rank", this.rank);
      formData.append("player_id", this.selectedPlayer ? this.selectedPlayer.value : "");
      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      this.loading = true;
      axios
        .post("/api/ranks/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    changeRank(item, diff) {
      // diff: -1ならアップ（rankを-1）、+1ならダウン（rankを+1）
      this.loading = true;
      const api = diff === -1 ? "/api/ranks/up" : "/api/ranks/down";
      axios
        .post(api, { id: item.id })
        .then(() => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    renumber() {
      if (!this.search_school_code) {
        return;
      }
      this.loading = true;
      axios
        .post("/api/ranks/renumber", {
          school_code: this.search_school_code,
          sex: this.search_sex,
        })
        .then(() => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
  },
  watch: {
    selectAll: function (newValue, oldValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
  },
};
</script>
<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-12 col-md-4">
                <!-- 検索画面 学校コードセレクトボックス -->
                <b-form-group label="学校コード" label-cols-sm="3">
                  <b-form-select v-model="search_school_code" :options="schoolList" @change="searchItems"
                    class="form-select" :disabled="$store.getters.roles === 'user'"></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-4">
                <b-form-group label="性別" label-cols-sm="3">
                  <b-form-select v-model="search_sex" :options="[
                    { value: '', text: '' },
                    { value: 1, text: '男子' },
                    { value: 2, text: '女子' }
                  ]" @change="searchItems" class="form-select" style="width: 100px"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="fields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(rank)="{ item }">
                  <div class="d-flex align-items-center">
                    <span>{{ item.rank }}</span>
                    <button class="btn btn-sm btn-outline-secondary ms-3" @click="changeRank(item, -1)">
                      ▲
                    </button>
                    <button class="btn btn-sm btn-outline-secondary ms-1" @click="changeRank(item, 1)">
                      ▼
                    </button>
                  </div>
                </template>
                <template v-slot:cell(player_sex)="{ item }">
                  <span>
                    {{ item.player_sex === 1 ? "男子" : item.player_sex === 2 ? "女子" : "" }}
                  </span>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span><button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button></span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-primary me-3" type="button" v-b-modal.modal-renumber>
                    連番
                  </button>
                  <!-- <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add">
                    追加
                  </button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <!-- 追加・編集画面 学校コードセレクトボックス -->
                    <b-form-group label="学校コード" label-cols-sm="3">
                      <ValidationProvider name="学校コード" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="school_code" :options="schoolList" placeholder="学校を選択"
                            class="form-select" style="width: 200px"
                            :disabled="$store.getters.roles === 'user'"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="校内順位" label-cols-sm="3">
                      <ValidationProvider name="校内順位" :rules="{ required: true, min_value: 1, max_value: 9999 }">
                        <div slot-scope="ProviderProps">
                          <b-form-input type="number" style="width: 100px" v-model="rank"
                            autocomplete="off"></b-form-input>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="選手" label-cols-sm="3">
                      <ValidationProvider name="選手" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <v-select v-model="selectedPlayer" :options="filteredPlayers" label="text"></v-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <b-modal id="modal-renumber" title="確認" title-class="font-18" @ok="renumber">
      <p>連番にしてよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
